import Container from '@ui/container/container';
import SwitchV2 from '@ui/switch-v2/switch-v2';
import Text from '@ui/text/text/text';

interface ToggleProps {
  label?: string;
  value: boolean;
  sKey: string;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  onToggle: (val: string, on: boolean) => void;
  onLabel?: string;
  offLabel?: string;
  padding?: string;
}

const SettingsToggle = ({
  label,
  value,
  sKey,
  disabled = false,
  loading = false,
  fullWidth = false,
  onLabel = 'On',
  offLabel = 'Off',
  onToggle,
  padding = '16px',
}: ToggleProps) => {
  return (
    <Container
      padding={padding}
      background="var(--gray-900)"
      height="fit-content"
      borderRadius="8px"
      width={fullWidth ? '100%' : 'auto'}
      className={`flex ${fullWidth ? 'fd-row' : 'ai-center jc-space-between'}`}
      opacity={disabled ? 0.5 : 1}
    >
      {!fullWidth && (
        <Text tag="h6" className="H6">
          {label}
        </Text>
      )}
      <div style={{ flex: fullWidth ? 1 : 'unset', display: fullWidth ? 'flex' : 'block' }}>
        <SwitchV2
          on={value || false}
          onClick={onToggle}
          value={sKey}
          disabled={disabled}
          loading={loading}
          onLabel={onLabel}
          offLabel={offLabel}
          fullWidth={fullWidth}
        />
      </div>
    </Container>
  );
};

export default SettingsToggle;
